import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import moment from 'moment';
import get from 'lodash/get';
import { observable, computed } from 'mobx';
var Coupon = (_class = /*#__PURE__*/function (_Model) {
  function Coupon() {
    var _this;
    _classCallCheck(this, Coupon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Coupon, [].concat(args));
    _initializerDefineProperty(_this, "code", _descriptor, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor2, _this);
    _initializerDefineProperty(_this, "friendlyName", _descriptor3, _this);
    _initializerDefineProperty(_this, "description", _descriptor4, _this);
    _initializerDefineProperty(_this, "maxTotalRedemptions", _descriptor5, _this);
    _initializerDefineProperty(_this, "dateExpires", _descriptor6, _this);
    _initializerDefineProperty(_this, "duration", _descriptor7, _this);
    _initializerDefineProperty(_this, "couponType", _descriptor8, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor9, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor10, _this);
    _initializerDefineProperty(_this, "offType", _descriptor11, _this);
    _initializerDefineProperty(_this, "createdBy", _descriptor12, _this);
    _initializerDefineProperty(_this, "redeemedCount", _descriptor13, _this);
    _initializerDefineProperty(_this, "minimumTotal", _descriptor14, _this);
    return _this;
  }
  _inherits(Coupon, _Model);
  return _createClass(Coupon, [{
    key: "expired",
    get: function get() {
      return this.dateExpires ? this.dateExpires.isBefore(moment()) : false;
    }
  }, {
    key: "displayType",
    get: function get() {
      return this.couponType.type === 'REFERRAL_CODE' ? 'Referral' : 'Coupon';
    }
  }, {
    key: "status",
    get: function get() {
      if (this.expired || this.maxTotalRedemptions !== 0 && this.maxTotalRedemptions <= this.redeemedCount) {
        return 'expired';
      }
      return 'active';
    }
  }, {
    key: "parse",
    value: function parse(json) {
      var couponOffTypes = {
        AMOUNT_OFF: 'Amount Off',
        PERCENT_OFF: 'Percent Off'
      };
      return {
        id: json.id,
        code: json.code,
        workspaceId: json.workspace_id,
        friendlyName: json.friendly_name,
        description: json.description,
        maxTotalRedemptions: json.max_total_redemptions,
        dateExpires: json.date_expires ? moment(json.date_expires) : null,
        duration: json.duration,
        couponType: json.coupon_type,
        dateCreated: json.date_created ? moment(json.date_created) : null,
        dateModified: json.date_modified ? moment(json.date_modified) : null,
        createdBy: json.coupon_type.created_by_user_id && json.coupon_type.created_by_user_public_id ? this.rootStore.memberStore.setAndFetch({
          workspace_id: json.workspace_id,
          user_id: json.coupon_type.created_by_user_id,
          user_public_id: json.coupon_type.created_by_user_public_id
        }) : null,
        redeemedCount: json.redeemed_count,
        offType: _objectSpread({
          type: json.off_type.type,
          displayType: get(couponOffTypes, json.off_type.type, json.off_type.type)
        }, json.off_type.type === 'AMOUNT_OFF' ? {
          amountOff: json.off_type.amount_off
        } : {
          percentOff: json.off_type.percent_off
        }),
        maxOff: _objectSpread({
          type: json.off_type.type === 'AMOUNT_OFF' ? 'MAX_PERCENT_OFF' : 'MAX_AMOUNT_OFF'
        }, json.off_type.type === 'AMOUNT_OFF' ? {
          percentOff: json.max_off.percent_off
        } : {
          amountOff: json.max_off.amount_off
        }),
        minimumTotal: json.minimum_total
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "code", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "friendlyName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "maxTotalRedemptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dateExpires", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "duration", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "couponType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "offType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "createdBy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "redeemedCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "minimumTotal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "expired", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "status", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), _class);
export { Coupon as default };
//# sourceMappingURL=Coupon.js.map
